__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/b172c02/_next/";